<template>
  <div class="page">
    <f-header @change="onChangeCity">
      <div slot="message">
        <div v-if="userInfo" class="message-bell" @click="isShowMessage = true">
          <i class="icon iconfont icon-bell" title="消息"></i>
          <div v-if="unread_count > 0" class="unread">{{ unread_count }}</div>
        </div>
      </div>
    </f-header>

    <div v-loading="loading">
      <div class="channel-list">
        <div class="container">
          <div @click="changeArea(index)" v-for="(item, index) in areaList" :key="item.id" class="channel-item" :class="{ active: areaIndex == index }">
            {{ item.name }}
          </div>
        </div>
      </div>

      <div class="vr-list">
        <div class="container">
          <router-link target="_blank" :to="'/preview?id=' + (item.origin_id || item.id)" v-for="item in vrList" :key="item.id" class="vr-item">
            <el-image v-if="item.thumb_origin_preview" class="preview-img" :src="item.thumb_origin_preview" fit="cover"></el-image>
            <el-image v-if="item.thumb_preview" class="preview-img" :src="item.thumb_preview" fit="cover"></el-image>
            <div class="name v-ellipsis">{{ item.name }}</div>
          </router-link>
          <div class="no-data" v-if="vrList.length == 0 && !loading">暂无数据~</div>
        </div>
        <div v-if="last_page > page" class="load-more-btn" @click="getVrList(++page)">点击加载更多</div>
        <div v-if="last_page == page" class="no-more-data">没有更多数据了...</div>
      </div>
    </div>

		<message-list v-if="isShowMessage" :show.sync="isShowMessage" @change="unread_count = $event " />
		<message-alert v-if="isShowMessageFirst" :show.sync="isShowMessageFirst" :row="messageList[0]" @show-message="isShowMessage = true" />
    <f-footer></f-footer>
  </div>
</template>

<script>
import fHeader from './components/header';
import fFooter from './components/footer';
import messageList from './components/message-list';
import messageAlert from './components/message-alert'
import { mapGetters } from 'vuex'

export default {
  components: { fHeader, fFooter, messageList ,messageAlert },

  data() {
    return {
      loading: true,
      vrList: [],
      page: 1,
      page_size: 12,
      last_page: 1,
      unread_count: 0,
      isShowMessage: false,
      isShowCommet: false,
      comment_id: '',
      messageList: [],
      isShowMessageFirst: false,
      areaList: [],
      areaIndex: 0,
      config: this.config,
    };
  },

  computed:{
		...mapGetters(['userInfo'])
  },

  created() {
  	this.getCityList();
    this.getMessageList();
  },

  methods: {
    async getCityList(index) {
      try {
				let level  = this.userInfo.level;
				this.regionList = await this.$store.dispatch('user/getAreaList');
				this.onChangeCity(level == 1 ? this.regionList[0].child : this.regionList);
      } catch (e) {
       console.error(e)
      }
    },

    onChangeCity(data) {
      this.areaList = data;
      this.areaIndex = 0;
      this.getVrList(1);
    },

    //获取消息
    async getMessageList() {
      try {
        let res = await this.api.message.getMyMessage();
        this.messageList = res.data.data;
        this.unread_count = res.data.un_read_count;
        this.isShowMessageFirst = this.unread_count > 0;
      } catch (e) {
        console.error(e);
      }
    },

    async getVrList(page) {
      this.page = page ? page : this.page;
      if (this.page == 1) {
        this.vrList = [];
        this.last_page = 0;
      }
      if (this.areaList.length == 0) {
        this.vrList = [];
        this.loading = false;
        return;
      }
      this.loading = true;
      try {
        let res = await this.api.works.lists({
          page: this.page,
          page_size: this.page_size,
          area_id: this.areaList[this.areaIndex].id,
					is_recommend:1,
        });
        this.last_page = res.data.last_page;
        this.vrList = this.page == 1 ? res.data.data : this.vrList.concat(res.data.data);
      } catch (e) {
        console.error(e);
      }
      this.loading = false;
    },

    //切换村级数据
    changeArea(index) {
      if (this.areaIndex == index) {
        return;
      }
      this.areaIndex = index;
      this.page = 1;
      this.getVrList(1);
    },
  },
};
</script>

<style scoped lang="scss">
.page {
  min-width: 1200px;
  min-height: 100%;
  background: #fff;
  line-height: 1.5;
  font-family: PingFangSC-Regular, PingFang SC;
  background: #fff;
  margin: 0 auto;
}

.container {
  width: 1200px;
  margin: 0 auto;
}

.footer-placeholder {
  min-height: 100px;
}

.no-data {
  display: flex;
  align-items: center;
  justify-content: center;
  height: 400px;
  width: 100%;
}

.vr-list .container {
  display: flex;
  flex-wrap: wrap;
  min-height: 300px;
  align-content: flex-start;

  .vr-item {
    width: 282px;
    margin-right: 21px;
    margin-bottom: 21px;
    border: 1px solid rgba(238, 238, 238, 1);
    transition: all 0.3s ease;
    cursor: pointer;
    text-decoration: none;
    color: #333;
    width: 282px;

    &:hover {
      box-shadow: 0px 0px 20px 0px rgba(29, 92, 229, 0.24);
    }
  }

  .vr-item:nth-child(4n) {
    margin-right: 0;
  }

  .vr-item .cover {
    display: block;
    width: 282px;
    height: 266px;
  }

  .vr-item .name {
    padding: 14px;
    font-size: 16px;
  }
}

.channel-list {
  padding: 0 0 40px 0;

  .container {
    display: flex;
    flex-wrap: wrap;
  }

  .channel-item {
    display: flex;
    justify-content: center;
    align-items: center;
    padding: 30px 30px 25px 30px;
    font-size: 18px;
    cursor: pointer;
    position: relative;
  }

  .channel-item:first-child:after,
  .channel-item:last-child:after {
    content: '';
    position: absolute;
    left: -5000px;
    bottom: 0;
    width: 9999px;
    height: 1px;
    background: #eee;
  }

  .channel-item.active:before {
    content: '';
    position: absolute;
    height: 2px;
    width: calc(100% - 60px);
    left: 50%;
    transform: translateX(-50%);
    bottom: 17px;
    background: #1772ef;
  }
}

.no-more-data {
  padding: 20px 0 40px 0;
  text-align: center;
  color: #999;
}

.load-more-btn {
  background: #f9f9f9;
  padding: 20px 0;
  margin-bottom: 20px;
  text-align: center;
  cursor: pointer;
  color: #999;
}

.message-bell {
  position: relative;
  margin-right: 20px;
  cursor: pointer;
}

.message-bell .iconfont {
  font-size: 20px;
}

.message-bell .unread {
  position: absolute;
  display: flex;
  background: red;
  color: #fff;
  border-radius: 100%;
  right: -10px;
  top: -10px;
  align-items: center;
  justify-content: center;
  font-size: 12px;
  width: 25px;
  height: 25px;
  transform: scale(0.8);
}

.message-dialog .content {
  line-height: 1.5;
}

.preview-img {
  width: 282px;
  height: 266px;
}
</style>
